export default __webpack_public_path__ + "media/images/front/municipality_collaboration/oita/ogp-35c25b8acf7c83685d487bd2e2d31fec.png";